import { Link } from "react-router-dom";
import { faqs } from "@/data/faq";
import { useLive, fill } from "@/lib/serviceInfo";
import Layout from "@/components/Layout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

export default function Faq() {
  const live = useLive();
  return (
    <Layout>
      <section className="bg-[#3D2314] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#D4A574]/20 mb-4"><HelpCircle className="h-7 w-7 text-[#D4A574]" /></div>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4 font-display">Ofte stilte spørsmål om reparasjon av kaffemaskin</h1>
          <p className="text-white/80 max-w-2xl mx-auto">Svar på det kundene oftest lurer på – fra hvilke maskiner vi reparerer til pris, garanti og henting.</p>
        </div>
      </section>
      <section className="py-16 md:py-24 bg-[#FFF8F0]">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {faqs.map((t, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="bg-white rounded-lg border border-[#D4A574]/20 px-4">
                <AccordionTrigger className="text-base md:text-lg font-bold text-[#3D2314] text-left">{t.q}</AccordionTrigger>
                <AccordionContent forceMount className="text-sm text-[#1A1A1A]/80 leading-relaxed">{fill(t.a, live)}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          <div className="text-center mt-8">
            <p className="text-sm text-[#1A1A1A]/70">Fant du ikke svaret? Se <Link to="/vilkar" className="text-[#D4A574] underline">vilkårene</Link>, <Link to="/kontakt-skjema" className="text-[#D4A574] underline">kontakt oss</Link> eller <Link to="/innlevering" className="text-[#D4A574] underline">lever inn utstyret</Link>.</p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
